import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowup_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m561.707 323.584 194.389 262.23a60.416 60.416 0 0 1-13.312 85.077c-10.581 7.68-23.339 11.776-36.437 11.776H317.653A61.27 61.27 0 0 1 256 621.78c0-12.928 4.181-25.514 11.904-35.968l194.347-262.229a62.123 62.123 0 0 1 99.498 0z"
    />
  </svg>
);
export default SvgArrowupIcon;
